<template>
  <div class="activiti">
    <h3 class="activiti__title">
      {{ header }}
    </h3>
    <div :class="{
      'activiti__list': list,
      'activiti__list_full': fullList
    }">
      <BaseBtn
        v-for="(item, indexItem) in KeywordsDataFilter"
        :key="indexItem"
        :text="item?.Name"
        white
        :active="item.IsActive"
        @clickBtn="activeKeyword(item.Id, indexItem, item)"
      />
      <div class="activiti__block-adder">
        <BlockAdder
          @click="goToAdd()"
        />
      </div>
    </div>
    <div class="activiti__show-button">
      <BaseBtn
        @click="getFullList()"
        blue
        :text="list ? 'Все теги' : 'Скрыть теги'"
      />
    </div>
  </div>
  <AddTagsModal
    v-if="AddtagsModalVisible"
    :dropdownActive="false"
    :categoryId="activitiesId"
    keywordsEducation
  />
</template>

<script>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

import BaseBtn from '@/components/ui/BaseBtn.vue'
import BlockAdder from '@/components/elements/BlockAdder.vue'
import AddTagsModal from '@/components/modals/AddTagsModal.vue'

export default {
  name: 'KeywordsModalActivities',
  components: {
    BaseBtn,
    BlockAdder,
    AddTagsModal
  },
  props: {
    activitiesId: {
      type: Number,
      default: 0
    },
    header: {
      type: String,
      default: 'История'
    }
  },
  setup (props) {
    const store = useStore()

    const KeywordsDataFilter = computed(() => {
      return store.getters.getKeywordsDataFilter
    })

    const AddtagsModalVisible = computed(() => {
      return store.getters.getShowAddTagsEditor
    })

    const activeKeyword = (id, indexItem, item) => {
      store.commit('SetChangeKeywordsObj', item)
      store.commit('SetSelectedKeywords', {
        id: id,
        indexItem: indexItem
      })

      // разделение логики на два проекта с привязкой к значению из localStorage
      if (localStorage.activeProject === 'site') {
        if (props.activitiesId === 3) {
          store.dispatch('setCheckSearchTag', item)
        } else if (props.activitiesId === 2) {
          store.dispatch('setCheckSearchTagNews', item)
        } else if (props.activitiesId === 4) {
          store.dispatch('setCheckSearchTagServices', item)
        }
      } else if (localStorage.activeProject === 'education') {
        store.dispatch('setCheckSearchTagEducation', item)
      }
    }

    const list = ref(true)

    const fullList = ref(false)

    const goToAdd = () => {
      store.commit('SetShowAddTagsEditor', true)
    }

    const getFullList = () => {
      list.value = !list.value
      fullList.value = !fullList.value
    }

    return {
      goToAdd,
      AddtagsModalVisible,
      KeywordsDataFilter,
      getFullList,
      activeKeyword,
      list,
      fullList
    }
  }
}
</script>

<style lang="scss" scoped>
.activiti {
  margin-bottom: 30px;

  &__title {
    font-weight: 500;
    font-size: 20px;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: start;
  }

  &__list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    max-height: 175px;
    overflow: hidden;
    margin-bottom: 16px;
    padding: 16px 0;

    &_full {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
      margin-bottom: 16px;
      padding: 16px 0;
    }
  }

  &__show-button {
    display: flex;
    justify-content: space-around;
  }
}

::v-deep
  .base-button  {
    height: 38px;
  }
</style>
